import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

/**
 * Agrega `withCredentials: true` y `Accept: application/json` a todas las
 * requests dirigidas al backend de Laravel, para que las cookies de sesión
 * Sanctum se envíen automáticamente.
 */
export const credentialsInterceptor: HttpInterceptorFn = (req, next) => {
  if (isLaravelRequest(req.url)) {
    const headers: Record<string, string> = { Accept: 'application/json' };
    const xsrfToken = readCookie('XSRF-TOKEN');

    if (xsrfToken && !isSafeMethod(req.method)) {
      headers['X-XSRF-TOKEN'] = xsrfToken;
    }

    req = req.clone({
      withCredentials: true,
      setHeaders: headers,
    });
  }

  return next(req);
};

function isLaravelRequest(url: string): boolean {
  return url.startsWith(environment.apiUrl) || url.startsWith(`${environment.backendUrl}/sanctum`);
}

function isSafeMethod(method: string): boolean {
  return ['GET', 'HEAD', 'OPTIONS'].includes(method.toUpperCase());
}

function readCookie(name: string): string | null {
  if (typeof document === 'undefined') {
    return null;
  }

  const cookies = document.cookie ? document.cookie.split('; ') : [];
  const cookie = cookies.find((entry) => entry.startsWith(`${name}=`));

  if (!cookie) {
    return null;
  }

  return decodeURIComponent(cookie.split('=').slice(1).join('='));
}
